module.exports = __webpack_public_path__ + "59c6e6fe79837e13bc95c34842600053.MP3";